import { Catalogue } from '@/constants/catalogueIds'
import type { AlgoliaCollection } from '@/utils/algolia/autocompleteHitTypes'

export const filterCollectionsByUserCatalogues = <
	T extends Collection | AlgoliaCollection
>(
	collections: T[],
	user: User
): T[] => {
	const { viewableCatalogues } = user
	return collections.filter((collection) => {
		const hasViewableCatalogues = collection.catalogue?.some((catalogueName) =>
			viewableCatalogues.includes(
				Catalogue[catalogueName as keyof typeof Catalogue]
			)
		)

		return hasViewableCatalogues
	})
}
